import React, { useEffect } from "react";
import "./Header.css"; // Tạo file CSS mới hoặc thêm vào file CSS hiện có

function Header() {
  useEffect(() => {
    // Tạo hiệu ứng trái tim
    const createHeart = () => {
      const heart = document.createElement("div");
      heart.className = "heart-particle";
      heart.innerHTML = "♥";

      // Vị trí ngẫu nhiên trong header
      heart.style.left = Math.random() * 100 + "vw";
      heart.style.animationDuration = Math.random() * 2 + 3 + "s";

      document.querySelector(".header").appendChild(heart);

      // Xóa trái tim sau khi animation hoàn thành
      setTimeout(() => {
        heart.remove();
      }, 5000);
    };

    // Tạo trái tim mỗi 500ms
    const interval = setInterval(createHeart, 500);

    // Cleanup interval khi component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <header id="home" className="header valign bg-img parallaxie">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center caption">
            <h1 className="animate-box" data-animate-effect="fadeInUp">
              Thẩm Mỹ & Nhật Vương
            </h1>
            <h5 className="animate-box" data-animate-effect="fadeInUp">
              April 5, 2025 – Can Tho
            </h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="arrow bounce text-center">
              <a href="#couple">
                {" "}
                <i className="ti-heart"></i>{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
